import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { DOMAIN_HIERARCHY_LIMIT, NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { domainKeys } from '@/shared/lib/query/queryKeys';

import { createDomainApi } from '@/features/domain/api';
import type { CreateDomainRequest } from '@/features/domain/api';

export const useCreateDomain = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateDomainRequest) => createDomainApi(request),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: domainKeys.hierarchy(DOMAIN_HIERARCHY_LIMIT) });
      queryClient.invalidateQueries({ queryKey: domainKeys.domainTree });
      queryClient.invalidateQueries({ queryKey: domainKeys.subDomainsPrefix() });

      if (variables.parent) {
        queryClient.invalidateQueries({ queryKey: domainKeys.detail(variables.parent) });
      }

      notification.success({
        message: NOTIFICATION_MESSAGES.DOMAIN_CREATE_SUCCESS,
        description: NOTIFICATION_MESSAGES.DOMAIN_CREATE_SUCCESS_DESC,
        placement: 'bottomLeft',
        duration: 3,
      });
    },
  });
};
